import React from "react";
import "./style.css";

// images
import img1 from "../../assets/images/Destop-wallpaper.webp";
// import img2 from "../../assets/images/Flower-Head-1.webp";
// import img3 from "../../assets/images/Flower-Head-2.webp";
// import img4 from "../../assets/images/Lock-wallpaper.webp";

import Navigation from "../../components/Navigation";
import { Helmet } from "react-helmet-async";

// const portfolioItems = [
//     { id: 1, image: img1, title: "Desktop Art", category: "Digital" },
//     { id: 2, image: img2, title: "Floral Study I", category: "VFX" },
//     { id: 3, image: img3, title: "Floral Study II", category: "VFX" },
//     { id: 4, image: img4, title: "Locked In", category: "Concept" },
// ];

const Visuals = () => {
    return (
        <div className="collection-container">
            <main className="collection-main">
                <Navigation />
				<Helmet>
					<title>Visual Portfolio - Big Cat Graphics</title>
					<meta name="description" content="Explore the visual portfolio of Big Cat Graphics, showcasing a diverse range of captivating images that demonstrate creativity and technical skills in digital art." />
				</Helmet>
                
                {/* Header Section */}
                <div className="threeD-header" style={{backgroundImage: `url(${img1})`}}>
                    <h1 className="threeD-title">Visual Portfolio</h1>
                    <p className="threeD-subtitle">
                        A showcase of my visual effects projects, demonstrating creativity and technical skills in digital art.
                    </p>
                </div>

                {/* Featured Video Section */}
				<section className="video-section" style={{ padding: '40px 20px', textAlign: 'center' }}>
					<h2 style={{ marginBottom: '20px' }}>Featured Projects</h2>
					<h2 style={{ marginBottom: '10px', color: '#555' }}>CGI & VFX Showreel</h2>
					<div style={{ 
						maxWidth: '800px', 
						margin: '0 auto', 
						aspectRatio: '16 / 9', // Modern way to handle height
						width: '100%',
						background: '#000', // Shows a black box if the video fails to load
						borderRadius: '12px',
						overflow: 'hidden'
					}}>
						<iframe
							width="100%"
							height="100%"
							src="https://www.youtube.com/embed/UyIKDhwWm9M"
							title="Visual Portfolio Video"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowFullScreen
						></iframe>
					</div>
				</section>

				<section className="video-section" style={{ padding: '40px 20px', textAlign: 'center' }}>
					<h2 style={{ marginBottom: '20px' }}>Music In Green</h2>
					<h2 style={{ marginBottom: '10px', color: '#555' }}>Pilot</h2>
					<div style={{ 
						maxWidth: '800px', 
						margin: '0 auto', 
						aspectRatio: '16 / 9', // Modern way to handle height
						width: '100%',
						background: '#000', // Shows a black box if the video fails to load
						borderRadius: '12px',
						overflow: 'hidden'
					}}>
						<iframe
							width="100%"
							height="100%"
							src="https://www.youtube.com/embed/6nPHKbf9nZc?si=HM23yxamClgfV_0H" 
							title="Visual Portfolio Video"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowFullScreen
						></iframe>
					</div>
				</section>
				
				<section className="video-section" style={{ padding: '40px 20px', textAlign: 'center' }}>
					<h2 style={{ marginBottom: '10px', color: '#555' }}>Episode 1: Khaeda And Pot3nt</h2>
					<div style={{ 
						maxWidth: '800px', 
						margin: '0 auto', 
						aspectRatio: '16 / 9', // Modern way to handle height
						width: '100%',
						background: '#000', // Shows a black box if the video fails to load
						borderRadius: '12px',
						overflow: 'hidden'
					}}>
						<iframe
							width="100%"
							height="100%"
							src="https://www.youtube.com/embed/CK30QdGy2So?si=GL8C4Tt9TTTTeEFo" 
							title="Visual Portfolio Video"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowFullScreen
						></iframe>
					</div>
				</section>

				<section className="video-section" style={{ padding: '40px 20px', textAlign: 'center' }}>
					<h2 style={{ marginBottom: '10px', color: '#555' }}>Episode 2: Silas Africa and Ntsiki Mazwai</h2>
					<div style={{ 
						maxWidth: '800px', 
						margin: '0 auto', 
						aspectRatio: '16 / 9', // Modern way to handle height
						width: '100%',
						background: '#000', // Shows a black box if the video fails to load
						borderRadius: '12px',
						overflow: 'hidden'
					}}>
						<iframe
							width="100%"
							height="100%"
							src="https://www.youtube.com/embed/cYqI0tao6EA?si=am72O2FQAqLPhf8z" 
							title="Visual Portfolio Video"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowFullScreen
						></iframe>
					</div>
				</section>

				<section className="video-section" style={{ padding: '40px 20px', textAlign: 'center' }}>
					<h2 style={{ marginBottom: '10px', color: '#555' }}>Episode 3: W X Y N and Wayne II</h2>
					<div style={{ 
						maxWidth: '800px', 
						margin: '0 auto', 
						aspectRatio: '16 / 9', // Modern way to handle height
						width: '100%',
						background: '#000', // Shows a black box if the video fails to load
						borderRadius: '12px',
						overflow: 'hidden'
					}}>
						<iframe
							width="100%"
							height="100%"
							src="https://www.youtube.com/embed/sEH-mCi6Jxc?si=ucX_KIkixMjWBeoG" 
							title="Visual Portfolio Video"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowFullScreen
						></iframe>
					</div>
				</section>

				<section className="video-section" style={{ padding: '40px 20px', textAlign: 'center' }}>
					<h2 style={{ marginBottom: '10px', color: '#555' }}>Episode 4: Kans And Itsjustmotheo</h2>
					<div style={{ 
						maxWidth: '800px', 
						margin: '0 auto', 
						aspectRatio: '16 / 9', // Modern way to handle height
						width: '100%',
						background: '#000', // Shows a black box if the video fails to load
						borderRadius: '12px',
						overflow: 'hidden'
					}}>
						<iframe
							width="100%"
							height="100%"
							src="https://www.youtube.com/embed/11X63ZAlE44?si=olRWN5yzpA8RtHpv" 
							title="Visual Portfolio Video"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowFullScreen
						></iframe>
					</div>
				</section>

				<section className="video-section" style={{ padding: '40px 20px', textAlign: 'center' }}>
					<h2 style={{ marginBottom: '10px', color: '#555' }}>Episode 5: Bothlale, Savakay, Pot3nt, Motheo and Silas</h2>
					<div style={{ 
						maxWidth: '800px', 
						margin: '0 auto', 
						aspectRatio: '16 / 9', // Modern way to handle height
						width: '100%',
						background: '#000', // Shows a black box if the video fails to load
						borderRadius: '12px',
						overflow: 'hidden'
					}}>
						<iframe
							width="100%"
							height="100%"
							src="https://www.youtube.com/embed/koZrMlQi_0E?si=0s4ytyYRnZS7V70p" 
							title="Visual Portfolio Video"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowFullScreen
						></iframe>
					</div>
				</section>

                {/* Portfolio Grid */}
                {/* <section className="threeD-wrapper">
                    <div className="threeD-grid">
                        {portfolioItems.map((item) => (
                            <div key={item.id} className="threeD-item">
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    className="threeD-image"
                                />
                                <div className="threeD-overlay">
                                    <div className="threeD-text">
                                        <h3>{item.title}</h3>
                                        <p>{item.category}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section> */}
            </main>
        </div>
    );
};

export default Visuals;